/**
 * The Return types for react-query keys, defines what kind of data is returned by the query.
 */
export type QueryKeyReturnType = 'LIST' | 'ITEM' | 'PAGINATED_LIST';

/**
 * Helper function to generate query keys by passing a key, the return type of the query and custom parameters.
 *
 * @param queryKeyIdentifier The key identifier.
 * @param resultType The result type of the query function expected.
 * @param params The parameters passed to the query functions
 * @returns The generated query key
 */
export function generateQueryKey<T extends readonly unknown[]>(queryKeyIdentifier: string, resultType: QueryKeyReturnType, ...params: T) {
    return [queryKeyIdentifier, resultType, ...params];
}
